'use client'

import { defineStyleConfig, extendTheme, withDefaultColorScheme } from '@chakra-ui/react'
import Popover from './components/popover'
import Modal from './components/modal'
import merge from 'lodash/merge'
import { defaultAppConfig } from '#/src/appConfig'
import { baseTheme } from './theme.base'

const Menu = defineStyleConfig({
  baseStyle: {
    list: {
      bg: 'background.default '
    },
    item: {
      bg: 'background.default'
    }
  }
})

const Checkbox = defineStyleConfig({
  defaultProps: {
    colorScheme: 'none'
  },
  baseStyle: {
    control: {
      _checked: {
        bg: 'primary'
      },
      _focus: {
        shadow: 'none'
      }
    }
  }
})

const Switch = defineStyleConfig({
  defaultProps: {
    colorScheme: 'gray'
  }
})

const Link = defineStyleConfig({
  baseStyle: {
    cursor: 'pointer'
  }
})

const Button = defineStyleConfig({
  baseStyle: {
    borderRadius: 'sm',
    color: 'text.light',
    fontWeight: 'medium',
    minW: 140,
    outlineOffset: 0,
    transition: 'all 0.35s cubic-bezier(.08,.52,.52,1)'
  },
  defaultProps: {
    size: 'md'
  }
})

const CustomFooter = defineStyleConfig({
  baseStyle: (props) => {
    const footerStyles = props.theme?.components?.CustomFooter || {}
    return {
      bg: 'background.surface',
      p: {
        base: 4,
        md: 10
      },
      ...footerStyles
    }
  }
})

export const defaultTheme = extendTheme(
  withDefaultColorScheme({
    colorScheme: 'primary'
  }),
  {
    ...baseTheme,
    components: {
      Checkbox,
      Popover,
      Switch,
      Link,
      Button,
      Menu,
      Modal,
      CustomFooter
    }
  }
)

export const customTheme = merge(defaultTheme, defaultAppConfig.config.theme)
